import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export type AppLanguage = 'es' | 'en';

const STORAGE_KEY = 'sbest-lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private currentLang$ = new BehaviorSubject<AppLanguage>('es');

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['es', 'en']);

    const saved = this.getSavedLang();
    this.setLanguage(saved);
  }

  get currentLanguage(): AppLanguage {
    return this.currentLang$.value;
  }

  get currentLanguage$() {
    return this.currentLang$.asObservable();
  }

  setLanguage(lang: AppLanguage): void {
    this.translate.use(lang);
    this.currentLang$.next(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }

  toggleLanguage(): void {
    const next = this.currentLang$.value === 'es' ? 'en' : 'es';
    this.setLanguage(next);
  }

  private getSavedLang(): AppLanguage {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'es') {
      return saved;
    }
    return 'es';
  }
}
